import styled from "styled-components";
import { FAQSBackground } from "./FAQSBackground";
import { FAQSContactUs } from "./FAQSContactUs";
import { FAGSAskedQuestions } from "./FAGSAskedQuestions";
import { MainFooter } from "../../Footer/MainFooter";

export function ComponentFAQs({ pageContent = {} }) {
	const { content = {} } = pageContent;
	return (
		<HomepageContainer>
			<FAQSBackground banner={content?.banner} />
			<BodyContainer>
				<FAGSAskedQuestions questions={content?.questions} />
			</BodyContainer>
			<BodyContainer>
				<FAQSContactUs contact_us={content?.contact_us} />
			</BodyContainer>
			<footer style={{ width: "100%" }}>
				<MainFooter />
			</footer>
		</HomepageContainer>
	);
}

const HomepageContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
`;
const BodyContainer = styled.div`
	max-width: 1442px;
	padding: 60px 136px 0px;
	width: 100%;
	&.home-utilities-container-outer {
		margin-top: 50px;
	}
	@media (max-width: 991px) {
		padding: 90px 80px;
		&.home-utilities-container-outer {
			margin-top: 40px;
		}
	}
	@media (max-width: 767px) {
		padding: 60px 32px;
		&.home-utilities-container-outer {
			margin-top: 30px;
		}
	}
	@media (max-width: 575px) {
		padding: 60px 20px;
		&.home-utilities-container-outer {
			margin-top: 20px;
		}
	}
`;
